export const CONST = {
    'TITLE_APP': 'mySedgwick',
    'WRONG_PASS_INFO': 'Your password is wrong',
    'LOGIN_INFO_ERROR': 'Unexpected login error',    
    'SESSION_EXPIRED': 'Your session expired',
    'USER_COOKIE_KEY': 'mysedgwick-user'
  };

